import React from 'react';
import { TextField, ReferenceField, FunctionField, Link, useCreatePath, useLocaleState } from 'react-admin';
import { Card, CardMedia, CardContent, Typography, Box } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import EastIcon from '@mui/icons-material/East';

import StatusField from './fields/StatusField';
import CategoryField from './fields/CategoryField';

const EventCard = ({ record }) => {
    const createPath = useCreatePath();
    const [locale] = useLocaleState();

    if (!record) {
        return null;
    }

    return (
        <Link to={createPath({ resource: 'events', id: record.id, type: 'edit' })} sx={{ textDecoration: 'none' }}>
            <Card sx={{ boxShadow: 'none', borderRadius: 0, height: '100%' }}>
                <Box m={2} sx={{ position: 'relative' }}>
                    {record.featured_image_url ? (
                        <CardMedia image={record.featured_image_url} sx={{ height: 140 }} />
                    ) : (
                        <Box sx={{ height: 140, backgroundColor: 'primary.main', opacity: 0.5 }} />
                    )}
                    {record.status && (
                        <Box sx={{ position: 'absolute', top: 0, padding: '4px' }}>
                            <StatusField record={record} />
                        </Box>
                    )}
                    {(record.status === 'accepted' && record.hasOwnProperty('published')) && (
                        <Box sx={{ position: 'absolute', top: 0, right: 0, padding: '4px', color: '#FFF' }}>
                            {record.published ? (
                                <VisibilityIcon />
                            ) : (
                                <VisibilityOffIcon />
                            )}
                        </Box>
                    )}
                    {(record.start_at && record.end_at) && (
                        <Box sx={{ position: 'absolute', bottom: 0, right: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                            <Typography variant="subtitle1" sx={{ backgroundColor: '#FFF', marginBottom: '2px', px: '2px' }}>{new Date(record.start_at).toLocaleDateString(undefined, { timeZone: 'UTC' })}</Typography>
                            <Typography variant="subtitle1" sx={{ backgroundColor: '#FFF', px: '2px', display: 'flex', alignItems: 'center' }}><EastIcon sx={{ fontSize: '13px', mr: '3px' }} />{new Date(record.end_at).toLocaleDateString(undefined, { timeZone: 'UTC' })}</Typography>
                        </Box>
                    )}
                </Box>
                <CardContent>
                    {record.category && <Typography>#<CategoryField record={record} /></Typography>}
                    <Typography variant="h6">
                        {record.title}
                    </Typography>
                    <Typography>
                        <ReferenceField label="Country" source="country_id" reference="countries" link={false} allowEmpty record={record}>
                            <FunctionField
                                render={record => (record?.translations?.name && record?.translations?.name[locale]) ? record.translations.name[locale] : (record.name ? record.name : '')}
                            />
                        </ReferenceField>
                        {(record.country_id && record.region_id) && ` - `}
                        <ReferenceField label="Region" source="region_id" reference="regions" link="show" allowEmpty record={record}>
                            <TextField source="name" />
                        </ReferenceField>
                    </Typography>
                </CardContent>
            </Card>
        </Link>
    );
};

export default EventCard;